export default __webpack_public_path__ + "static/media/FeaturedEventsIcon1.bb7b05c7.png";